<ng-container *transloco="let t;">

    <div class="uploaded-files-list" [formGroup]="form"> 
        <div class="d-flex justify-content-start align-items-center columngap w-100">
            <div class="d-block w-100">
                <div class="d-flex">
                    <div class="uploaded-files-listing">
                        <div class="file-icon">
                            <i data-feather="file-text" size="16" class=""></i>
                        </div>
                        <div class="upload-files-info">
                            <h4 class="uploaded-file-name">{{ file?.name }}</h4>
                            <div class="uploaded-file-progressbar">
                                <ngb-progressbar type="success" [value]="progress"></ngb-progressbar>
                            </div>
                            <div class="uploaded-file-size-percent">
                                <span>{{ progress }}%</span>
                                 <span class="file-size">{{ file?.size | fileSize }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="file-delete-icon justify-content-end d-flex" (click)="onDelete()">
                        <i data-feather="trash-2" class="cursor-pointer" size="16"></i>
                    </div>
                </div>
                <div *ngIf="form && form.get('file').errors"
                     class="invalid-feedback d-block file-validation-field">
                    <div *ngIf="form.get('file').errors.maxSize">
                        {{ form.get('file').errors?.maxSize?.message }}
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 col-sm-12 d-flex justify-content-center columngap bulkUpload-rightColumn-border m-0 mt-1">
          <ng-content></ng-content>
        </div>
    </div>

</ng-container>
